module.exports = __webpack_public_path__ + "media/warranty-claim/photos-back-house2-76b002af.png";